import React from "react";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";

import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { InnerTeamScheduleAdminScreenComponent } from "./_TeamScheduleAdminScreen";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";
import {
  TeamScheduleAdminScreenProps,
  TeamScheduleAdminStack,
} from "./TeamScheduleAdminStack";
import { TeamScheduleAdminTemplateScreen } from "./TeamScheduleAdminTemplateScreen";
import { TeamScheduleAdminPendingRoutineCreatedProvider } from "./TeamScheduleAdminPendingRoutineCreatedProvider";
import { TeamScheduleAdminArchivedScreen } from "./TeamScheduleAdminArchivedScreen";

export const TeamScheduleAdmin = withWebModal(TeamScheduleAdminC);

function TeamScheduleAdminC(
  props: UserLoggedInNavigatorScreenProps<"TeamScheduleAdmin">
) {
  const getOpts = useNavigationHeaderOptions();
  const opts = getOpts({
    type: "CLOSE",
    title: "",
    onClose: () => {
      props.navigation.goBack();
    },

    disableBorder: true,
    defaultContentStyle: true,
  });

  return (
    <TeamScheduleAdminPendingRoutineCreatedProvider>
      <TeamScheduleAdminStack.Navigator initialRouteName="TeamScheduleAdminMain">
        <TeamScheduleAdminStack.Screen
          options={{
            ...opts,
          }}
          name="TeamScheduleAdminMain"
          component={TeamScheduleAdminScreen}
          initialParams={props.route.params}
        />
        <TeamScheduleAdminStack.Screen
          name="TeamScheduleAdminTemplates"
          component={TeamScheduleAdminTemplateScreen}
          options={({ navigation }) => ({
            ...getOpts({
              type: "BACK",
              title: "",
              onBack: () => {
                navigation.goBack();
              },
            }),
            defaultContentStyle: true,
          })}
        />
        <TeamScheduleAdminStack.Screen
          name="TeamScheduleAdminArchived"
          component={TeamScheduleAdminArchivedScreen}
          options={({ navigation }) => ({
            ...getOpts({
              type: "BACK",
              title: "",
              onBack: () => {
                navigation.goBack();
              },
              defaultContentStyle: true,
            }),
          })}
        />
      </TeamScheduleAdminStack.Navigator>
    </TeamScheduleAdminPendingRoutineCreatedProvider>
  );
}

function TeamScheduleAdminScreen(
  props: TeamScheduleAdminScreenProps<"TeamScheduleAdminMain">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fk) => (
        <InnerTeamScheduleAdminScreenComponent
          fetchKey={fk}
          teamId={props.route.params.teamId}
          navigation={props.navigation}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
